export const fciGroups = [
  {
    id: 1,
    name: '1 группа FCI',
  },
  {
    id: 2,
    name: '2 группа FCI',
  },
  {
    id: 3,
    name: '3 группа FCI',
  },
  {
    id: 4,
    name: '4 группа FCI',
  },
  {
    id: 5,
    name: '5 группа FCI',
  },
  {
    id: 6,
    name: '6 группа FCI',
  },
  {
    id: 7,
    name: '7 группа FCI',
  },
  {
    id: 8,
    name: '8 группа FCI',
  },
  {
    id: 9,
    name: '9 группа FCI',
  },
  {
    id: 10,
    name: '10 группа FCI',
  },
  {
    id: 0,
    name: 'вне классификации',
  },
];

export const expertSearchStatePropTypes = {
  name: 'string',
  email: 'string',
  country_id: 'integer',
};

export const expertDefaultSearchState = {
  name: '',
  email: '',
  country_id: 0,
  address: '',
  phones: '',
};

export const showSearchStatePropTypes = {
  name: 'string',
  starts_at: 'date',
  closed: 'string',
};

export const showDefaultSearchState = {
  name: '',
  starts_at: '',
  closed: '',
};
export const dogSearchStatePropTypes = {
  name: 'string',
  owner_email: 'string',
  sex: 'string',
  breed_id: 'integer',
  pedigree: 'string',
  date_of_birth: 'date',
  need_catalog: 'boolean',
};

export const dogDefaultSearchState = {
  name: '',
  owner_email: '',
  sex: '',
  breed_id: null,
  pedigree: '',
  date_of_birth: '',
  need_catalog: false,
};

export const registrationRequestDefaultSearchState = {
  name: '',
  sex: '',
  breed_id: null,
  pedigree: '',
  date_of_birth: '',
  need_catalog: '',
};

export const pagingPropTypes = {
  page: 'integer',
  perPage: 'integer',
}


export const showClasses = [
  { id: '', name_short: 'N',     name_short_ru: 'N',     name: 'Выберите класс', name_lat: 'Select class' },
  { id: 1,  name_short: 'Baby',  name_short_ru: 'бэби',  name: 'Класс бэби / Baby class', name_lat: 'Baby class' },
  { id: 2,  name_short: 'Puppy', name_short_ru: 'щенки', name: 'Класс щенков / Puppy class', name_lat: 'Puppy class' },
  { id: 3,  name_short: 'Jun',   name_short_ru: 'юниоры',   name: 'Класс Юниоров / Junior class', name_lat: 'Junior class' },
  { id: 4,  name_short: 'Int',   name_short_ru: 'промежут.',   name: 'Промежуточный класс / Intermediate class', name_lat: 'Intermediate class' },
  { id: 5,  name_short: 'Open',  name_short_ru: 'открытый',  name: 'Открытый класс / Open class', name_lat: 'Open class' },
  { id: 6,  name_short: 'Work',  name_short_ru: 'рабочий',  name: 'Рабочий класс / Working class', name_lat: 'Working class' },
  { id: 7,  name_short: 'Champ', name_short_ru: 'чемпионы', name: 'Класс чемпионов / Champion class', name_lat: 'Champion class' },
  { id: 8,  name_short: 'Vet',   name_short_ru: 'ветераны',   name: 'Класс ветеранов / Veteran class', name_lat: 'Veteran class' },
]

export const dogSexes = {
  1: 'Кобель / Male', 
  2: 'Cука / Female',
  male: 'Кобель / Male', 
  female: 'Cука / Female',
};